// extracted by mini-css-extract-plugin
export var animationContainer = "_jo-0";
export var footer = "_jo-1";
export var gray = "_jo-2";
export var lineItem = "_jo-3";
export var lineItemImage = "_jo-4";
export var lineItemInfo = "_jo-5";
export var lineItemText = "_jo-6";
export var lineItems = "_jo-7";
export var modalContent = "_jo-8";
export var options = "_jo-9";
export var orderName = "_jo-a";
export var refundAmount = "_jo-b";